// extracted by mini-css-extract-plugin
module.exports = {"stylists":"stylist-list_stylists__lc4F7","stylist":"stylist-list_stylist__bMavi"};